import React from "react";
import Header from "../components/ui/header";
import "../design/about.css";
import Footer from "../components/ui/footer";

const About = () => {
  return (
    <div className="about-page">
      <Header />
      <div className="about-body">
        <div className="about-container">
          <section>
            <h2>Who We Are</h2>
            <p>
              <strong>Deliquent Auction</strong> is your dedicated platform for discovering
              public delinquent property leads — streamlined, centralized, and actionable.
              Our mission is to bring clarity and convenience to real estate investors,
              wholesalers, and professionals by offering an all-in-one solution to find
              and manage leads with ease.
            </p>
          </section>

          <section>
            <h2>Our Mission</h2>
            <p>
              Our goal is simple: to make accessing and organizing delinquent property
              data as effortless as possible. We help you locate tax deeds, foreclosures,
              sheriff sales, and more — all in one place — with the tools to manage basic CRM needs
              for staying up to date with auction properties.
            </p>
          </section>

          <section>
            <h2>Why We Founded This</h2>
            <p>
              We recognized a gap in the real estate space. Data was scattered, outdated, overpriced,
              or hard to act on. So, we built <strong>Deliquent Auction</strong> to be a one-stop-shop —
              equipping users with everything they need to chase down opportunities in
              tax deed and foreclosure markets from a single dashboard.
            </p>
          </section>

          <section>
            <h2>Disclosures</h2>
            <ul>
              <li>All parcel data displayed on <strong>Deliquent Auction</strong> is publicly available information.</li>
              <li>We do not claim ownership over this data.</li>
              <li>Properties are only kept in the database for 7 days following their <strong>Sale/Auction Date</strong></li>
              <li>
                We utilize third-party services to enrich leads with additional information. 
                So, while our data is extremely accurate, we do not guarantee 100% precision due to the nature of our sources.
              </li>
              <li>
                The Search Address found in expanded cards is the string we use to gather information about a property.
                Always double check this against the address at the top of a card to validate addresses and information about a property.
              </li>
            </ul>
          </section>

          <section>
            For inquiries please send us an email at <strong>support@deliquentauction.com</strong>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
